import { useState, useEffect, useMemo } from 'react';
import { DgtPdOrderPicklist } from '../models'
import { getDates } from '../utilities/Format'
import { PicklistStatus } from '../constants/EnumType'
import { 
  getPdRecordedOrderPicklists,
  getCompletedOrderPicklists
} from '../states/PicklistAction'

export default function useCompletedOrderPicklist(
  status: string,
  orderType: string,
  dateFrom: Date,
  dateTo: Date,
  searchByOrder: string,
  division: string
) : DgtPdOrderPicklist[] {
  const [picklists, setPicklists] = useState<DgtPdOrderPicklist[]>([]);

  useEffect(() => {
    const periodDates = getDates(dateFrom, dateTo)
    
    Promise.allSettled(periodDates.map(date => {
      if (status === PicklistStatus.PD_RECORDED) {
        return getPdRecordedOrderPicklists(date, division, orderType)
      } else if (status === PicklistStatus.PICKLIST_COMPLETED) {
        return getCompletedOrderPicklists(date, division, orderType)
      }
      return Promise.reject(`Picklist Status not supported : ${status}`)
    })).then(results => {
      const totalPicklists = (results
        .filter(res => res.status === 'fulfilled') as PromiseFulfilledResult<DgtPdOrderPicklist[]>[])
        .reduce((prev, cur) => [...prev, ...cur.value], [] as DgtPdOrderPicklist[])
      setPicklists(totalPicklists)
    })
    .catch(err => console.error(err))
  }, [ status, orderType, dateFrom, dateTo, division ]);

  const filteredPicklists = useMemo(() => picklists.filter(pl => pl.pk.includes(searchByOrder)), [ searchByOrder, picklists ])
  return filteredPicklists
}